import React from 'react'
import { useQueryClient } from 'react-query'

import { ReactivateButton } from 'components/configurations/common/ReactivateButton'
import useAuth from 'hooks/use-auth'
import { integrationClientsQueryKeys } from 'queries/integration-clients/query-keys'
import { usePutIntegrationClientsActivate } from 'queries/integration-clients/use-put-integration-clients-activate'
import { type PrivateNetworkIntegrationClient } from 'types/api/integration-clients/integration-clients'

export const ActivatePrivateNetworkIntegrationClientButton: React.FC<{
  integrationClient: PrivateNetworkIntegrationClient
}> = ({ integrationClient }) => {
  const { currentTeamId: teamId } = useAuth()
  const queryClient = useQueryClient()

  const { mutateAsync: mutateActivateIntegrationClient } =
    usePutIntegrationClientsActivate(integrationClient.identifier)

  const handleSuccess = async () => {
    await queryClient.invalidateQueries(
      integrationClientsQueryKeys.get({ teamId })
    )
  }

  return (
    <ReactivateButton
      onConfirmRequest={mutateActivateIntegrationClient}
      onSuccess={handleSuccess}
    />
  )
}
